// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Header.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import React from 'react';

import connect from 'share/enhancers/Izenda.Connect';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import { isEmpty, forEach, uniqueId, take } from 'lodash/fp';

const Header = connect()(props => {
  function renderColumn() {
    const columns = [];
    props.model &&
      !isEmpty(props.model.permissionSummary) &&
      forEach(item => {
        columns.push(
          <GridLayout.Col cols="1" className="grid-small-column u_borderRight" key={uniqueId(item.id)}>
            &nbsp;
          </GridLayout.Col>
        );
      }, take(12, props.model.permissionSummary));
    return columns;
  }

  return (
    <div onClick={props.collapseToggle}>
      <GridLayout.Row className="u_noMarginAll">
        <GridLayout.Col cols="12" className="u_noPaddingAll">
          <GridLayout.Col cols="3" className="grid-small-column u_borderRight u-bgGrayBlue text-bold">
            <i className="icon-toggle-triangle" />
            <label className="panel-title">{props.headerName}</label>
          </GridLayout.Col>
          <GridLayout.Col cols="9" className="u_noPaddingAll">
            <GridLayout.Row className="u_noMarginAll">
              <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGray">
                {renderColumn()}
              </GridLayout.Col>
            </GridLayout.Row>
          </GridLayout.Col>
        </GridLayout.Col>
      </GridLayout.Row>
    </div>
  );
});

export default Header;



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/PermissionSummary/Izenda.Header.js